import { render, staticRenderFns } from "./ClientMembers.vue?vue&type=template&id=6fae191a&scoped=true"
import script from "./ClientMembers.vue?vue&type=script&lang=js"
export * from "./ClientMembers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fae191a",
  null
  
)

export default component.exports